class Monitoring.Methods.ErrorHandler

  constructor: (@error) ->
    # nothing to do

  handle: ->
    title = "Uncaught error"
    @_handle(title)

  handleWithSource: (url, line_number, col_number) ->
    title = "Uncaught error in: #{url} line #{line_number} col #{col_number}"
    @_handle(title)

  _handle: (title) ->
    message = @fetchMessage()
    browser = @fetchBrowserName()
    version = @fetchApplicationVersion()
    uniqueId = @fetchUniqueId()
    log = title
    log += "\nMessage: #{message}" if message
    log += "\nStack: #{@error.stack}" if (@error && @error.stack)
    log += "\nCode loaded at: #{version}" if (version)
    log += "\nUnique window ID: #{uniqueId}"
    log += "\nBrowser: #{browser}" if (browser)
    log += "\nFull user agent: #{navigator.userAgent}"
    window.jsLogger.fatal(log)

  fetchMessage: ->
    # sometimes the error has no message
    @error && (@error.message || @error.toString())

  fetchBrowserName: ->
    # https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
    # returns something like 'Chrome 64'
    try
      ua = navigator.userAgent
      tem = undefined
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) or []
      if /trident/i.test(M[1])
        tem = /\brv[ :]+(\d+)/g.exec(ua) or []
        return 'IE ' + (tem[1] or '')
      if M[1] == 'Chrome'
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
        if tem != null
          return tem.slice(1).join(' ').replace('OPR', 'Opera')
      M = if M[2] then [M[1], M[2]] else [navigator.appName, navigator.appVersion, '-?']
      if (tem = ua.match(/version\/(\d+)/i)) != null
        M.splice 1, 1, tem[1]
      M.join ' '
    catch e
      undefined

  fetchUniqueId: ->
    UniqueId.get('application_error_handler')

  fetchApplicationVersion: ->
    # TODO real application.js version
    # A timestamp is enought for now..
    @constructor.timestamp

  date = new Date()
  @timestamp: date.toISOString && date.toISOString()
